<template>
    <div class="common_dialog" v-show="dialogParams.flag" @touchmove.prevent @mousewheel.prevent>
        <div class="dialog_inner">
            <div class="dialog_top" :style="{padding:(dialogParams.messageTips&&dialogParams.messageTips!='')?'15px 15px 12px':'30px 15px 25px'}">
                <div class="dialog_message">{{dialogParams.message}}</div>
                <div class="dialog_messageTips" v-if="dialogParams.messageTips && dialogParams.messageTips!=''">{{dialogParams.messageTips}}</div>
            </div>
            <div class="dialog_button">
                <span @click="cancel">{{dialogParams.cancelHtml}}</span>
                <span class="ok" @click="confirm" v-html="dialogParams.confirmHtml"></span>
            </div>
        </div>
    </div>
</template>
<style lang="less" scoped>
.common_dialog{
    width: 100%;
    height: 100%;
    background: @toastMask;
    position: fixed;
    top:0;
    left:0;
    z-index: 1010;
    .dialog_inner{
        width: 270px;
        min-height: 112px;
        position: fixed;
        top:50%;
        left:0;right:0;
        transform: translate(0,-50%);
        margin:auto;
        background: @expertFontColor255;
        border-radius:4px;
        .dialog_top{
            padding: 30px 15px 25px;
            text-align: center;
            border-bottom: 1px solid rgba(229,229,229,1);
            .dialog_message{   
                font-size:@indexFontSize16;
                font-weight:400;
                color:@expertFontColor51;
            }
            .dialog_messageTips{
                margin-top:10px;
                font-size:@indexFontSize12;
                color:@expertFontColor153;
            }
        }
        .dialog_button{
            span{
                width: 135px;
                display: inline-block;
                padding: 12px 0;
                text-align: center;
                font-weight:500;
                font-size:@indexFontSize16;
                color:@expertFontColor51;
            }
            span.ok{
                width:134px;
                color:@mainColor;
                border-left: 1px solid rgba(229,229,229,1);
                a{
                    display: inline-block;
                    color:@mainColor;
                }
            }
        }
    }
}
</style>
<script>
export default {
    data() {
        return {
            
        }
    },
    props:["dialogParams"],
    mounted(){
        
    },
    methods:{
        cancel:function(){
            this.dialogParams.flag=false;
        },
        confirm:function(){
            this.dialogParams.flag=false;
            if(this.dialogParams.confirm){
                this.dialogParams.confirm();
                if(this.dialogParams.emitFn){
                    this.$emit("clearRecordList");
                }
            }
        }
    }
}
</script>